<template>
  <base-toolbar>
    <BackToFlatplan />
  </base-toolbar>
</template>

<script>
import { inject } from "vue"

import BackToFlatplan from "@/components/BackToFlatplan"

export default {
  name: "SectionToolBar",
  components: { BackToFlatplan },
  setup() {
    let mobile = inject("mobile")

    return {
      mobile,
    }
  },
}
</script>

<style lang="scss" scoped></style>
